import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import * as constants from "Constants";
import httpService from 'services/httpService.js';
import { Button, Card } from "react-bootstrap";
import moment from "moment";
// import Navbar from "../../../Layout/Common/Components/NavBar";
import ChoiceQuestion from "../Components/QuestionTypes/ChoiceQuestion"
import FillBlanks from "../Components/QuestionTypes/FillBlanks";
import Subjective from "../Components/QuestionTypes/Subjective";
import Numeric from "../Components/QuestionTypes/Numeric";
import './style.css';
import parse from 'html-react-parser';
import {
  Breadcrumb,
  // Dropdown,
  // DropdownButton,
  // Form,
  // ProgressBar,
  // Spinner,
} from "react-bootstrap";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";
import log from "loglevel";
import { Skeleton } from "primereact/skeleton";



var submitted = true;
var courseId = "1";
var program_id = "1";
var labTitle = ""
const Question = React.forwardRef((props, ref) => {
  //const Question = (props) => {
  log.log("question props ", props)
  const { labId, question, index, previousResponse, updateResponse, labAvailableTime, dis, Eval } = props;
  // log.log("PROPS for question:", props)
  const [today, setToday] = useState(new Date());
  const { question_type, marks, questionanswer_set } = question;
  const { response_options_ids } = previousResponse
  // const disable = !moment(labAvailableTime).isAfter(today);
  log.log("before --->", dis)
  const disable = moment(labAvailableTime).isBefore(moment(today)) || dis || submitted;
  const evaluated =
    // const disable = false
    log.log("Evaluation -->", Eval);
  // const disable = true
  log.log("question  : ", question)
  const autoCalculateScoredMarks = async (scored_marks) => {
    // log.log("autoCalculating Marks function")
    // const response = await actions.autoCalculateScoredMarksRequest(question, previousResponse.id, scored_marks);
    updateResponse();
  }
  useEffect(() => {
    const doStuff = async () => {
      let correct_answers = 0;
      updateResponse();
      //  log.log("result calculate-2",question_type,response_options_ids)

      if (question_type == "S" || question_type == "M") {

        if (Array.isArray(questionanswer_set)) {
          for (let ans of questionanswer_set) {
            if (response_options_ids && response_options_ids.includes(ans.answer_option)) {
              correct_answers += 1;
            } else {
              correct_answers -= 1
            }
          }
          // log.log("result cqalculate")
          if (correct_answers == questionanswer_set.length) {
            autoCalculateScoredMarks(marks)
          } else {
            autoCalculateScoredMarks(0.0);
          }
        }

      } else if (question_type == "N") {
        // log.log("set", questionanswer_set[0].answer)
        let trimmedString = questionanswer_set[0].answer.trim()
        let onlyOptions = trimmedString
        if (trimmedString[0] == '[') {
          onlyOptions = trimmedString.slice(1, -1);
        }

        let allPossible = onlyOptions.split(',');
        let numerals = allPossible
        // if (numerals[0][0] == '\'')
        //   numerals = allPossible.map((str) => str.trim().slice(1, -1))

        // if (numerals.includes(previousResponse.response_text)) {
        //   autoCalculateScoredMarks(marks)
        // }
        // else {
        //   autoCalculateScoredMarks(0)
        // }


        log.log(numerals);
        if (numerals[0][0] == '\"' || numerals[0][0] == '\'') {
          numerals = numerals.map((str) => str.trim().slice(1, -1))
        }

        numerals = numerals.map(parseFloat);

        log.log(numerals);
        log.log(parseFloat(previousResponse.response_text));

        if (numerals.includes(parseFloat(previousResponse.response_text))) {
          autoCalculateScoredMarks(marks);
        }
        else {
          autoCalculateScoredMarks(0);
        }
      } else if (question_type == "F") {
        log.log("Fill in the blanks, ", questionanswer_set)
        let lines = previousResponse.response_text?.split?.(/\r?\n/);
        if (lines?.length != questionanswer_set?.length) {
          autoCalculateScoredMarks(0);
          return;
        }

        let num_words = lines.length;
        for (var i = 0; i < num_words; i++) {
          let blanksInsensitive = false;
          let caseInsensitive = false;
          let ans_string = questionanswer_set[i].answer.slice(1, -1);
          let resp_string = lines[i];
          let start = 0
          if (ans_string.length > 4 && ans_string.slice(0, 4) == "(?b)") {
            blanksInsensitive = true;
            start = 4;
          }
          if (ans_string.length > 4 && ans_string.slice(0, 4) == "(?i)") {
            caseInsensitive = true;
            start = 4;
          }

          if (ans_string.length > 8 && ans_string.slice(4, 8) == "(?b)") {
            blanksInsensitive = true;
            start = 8;
          }

          if (ans_string.length > 8 && ans_string.slice(4, 8) == "(?i)") {
            caseInsensitive = true;
            start = 8;
          }

          ans_string = ans_string.slice(start);
          if (caseInsensitive) {
            ans_string = ans_string.toUpperCase();
            resp_string = resp_string.toUpperCase();
          }

          if (blanksInsensitive) {
            ans_string = ans_string.replace(/\s/g, "");
            resp_string = resp_string.replace(/\s/g, "");
          }

          if (ans_string != resp_string) {
            autoCalculateScoredMarks(0);
          }

        }
        autoCalculateScoredMarks(marks);
      }
    }
    doStuff();
  }, []);

  switch (question_type) {
    case "S":
    case "M":
      //return <div ref={ref}><ChoiceQuestion courseId={labId} question={question} index={index} previousResponse={previousResponse} updateResponse={updateResponse} disable={disable} Eval={Eval}/></div>;
      return <div ref={ref}><ChoiceQuestion courseId={labId} question={question} index={index} previousResponse={previousResponse} updateResponse={updateResponse} disable={disable} Eval={Eval} /></div>;

    case "D":
      return <div ref={ref}><Subjective courseId={labId} question={question} index={index} previousResponse={previousResponse} updateResponse={updateResponse} disable={disable} Eval={Eval} /></div>;
    case "F":
      return <div ref={ref}><FillBlanks courseId={labId} question={question} index={index} previousResponse={previousResponse} updateResponse={updateResponse} disable={disable} Eval={Eval} /></div>;
    case "N":
      return <div ref={ref}><Numeric courseId={labId} question={question} index={index} previousResponse={previousResponse} updateResponse={updateResponse} disable={disable} Eval={Eval} /></div>;
    default:
      return <div>Error in question</div>;
  }
});


const GradeSubmission = (props) => {
  const [otherActivityData, setOtherActivityData] = useState(JSON.parse(localStorage.getItem('quiz_data')));
  var activityTitle = '';
  const activityDescription = '';
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  log.log({ params })
  const [isDisabled, setIsDisabled] = useState(true);
  const url = location.pathname;
  const urlArray = url.split('/');
  const [labId, setLabID] = useState(urlArray[6]);
  let activity_evaluated = otherActivityData?.evaluated;
  const [labAvailableTime, setLabAvailableTill] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(true);
  const questionRefs = useRef([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(null);
  const [studentFiles, setStudentFiles] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const seenQuestions = new Set();
  const seenQuestions2 = new Set();
  const [tot_marks, setMarks] = useState(null); // Change the order of declaration 
  labTitle = otherActivityData?.lab_data?.title;
  program_id = otherActivityData?.id;
  activityTitle = otherActivityData?.name;
  const scrollToQuestion = (index) => {
    if (questionRefs.current[index]) {
      questionRefs.current[index].scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const updateResponse = (updateresp) => {
    log.log("nothing to update");
  }

  const downloadLabFiles = async () => {
    try {
      let _url = constants.base_url + "/otherlabs/activity/";
      let downloadFilesUrl = _url + otherActivityData['id'] + "/other_submission_download_lab_files?stud_id=" + encodeURIComponent(params['studentID']) + "&username=" + encodeURIComponent(params['studentID']);

      const response = await httpService.get(downloadFilesUrl, {
        responseType: 'blob'
      });

      let filename = `${params['studentID']}_lab_${otherActivityData['id']}_files_.tar.gz`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      log.error('Error downloading the file:', error.response);
      if (error?.response?.headers?.['content-type']?.includes?.('application/json')) {
        // The response is JSON, so parse it as text and then convert to JSON
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        log.log({json});
        if (json.error_title && json.error_desc) {
          let message = <><b>{json.error_title}</b><p className="mb-0">{json.error_desc}</p></>
          displayGlobalMessage(message, "error");
        } else {
          displayGlobalMessage('Failed to download the file.', 'error');
        }
      } else {
        displayGlobalMessage('Failed to download the file.', 'error');
      }
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      const url = location.pathname;
      const parts = url.split('/');
      const lastPart = parts[parts.length - 1];
      const email = lastPart.split('?')[0];
      var act_data = JSON.parse(localStorage.getItem('quiz_data'));
      var stud_data = JSON.parse(localStorage.getItem('student_quiz_data'));
      let urlArray = url.split("/");
      let activityID = urlArray[urlArray.length - 3];
      log.log(urlArray, "array");

      try {

        const base_other_activity_submissions_url = `${constants.base_url}/otherlabs/activity/${activityID}/other_activity_submissions`
        const students_data_url = `${base_other_activity_submissions_url}/${email}/`;
        const response = await fetch(students_data_url);
        const jsonData = await response.json();
        stud_data = jsonData.data;
        setMarks(stud_data[email]['total_marks'])
        //tot_marks = stud_data[email]['total_marks']
        const required_files = stud_data[email]['required_files'];
        stud_data = stud_data[email]['responses'];
        //tot_marks = stud_data[email]['total_marks']
        log.log("all students total marks", tot_marks)
        const updatedOtherActivityDetails = { ...act_data };
        updatedOtherActivityDetails['requiredfiles_set'] = required_files;
        let updated = false; // Flag to track if otherActivityDetails has been updated            
        for (let i = 0; i < updatedOtherActivityDetails?.question_set?.length; i++) {
          const question = updatedOtherActivityDetails.question_set[i];
          const matchingResponse = stud_data.find(item => item.question === question.id);
          if (matchingResponse) {
            // Replace questionresponse_set with matching response data
            question.questionresponse_set = matchingResponse;
            log.log("okkkk matches ", question.id, question);
            updated = true;
          }
        }

        if (updated) {
          log.log({ updatedOtherActivityDetails });
          setOtherActivityData(updatedOtherActivityDetails);
        } else {
          setOtherActivityData(data => {
            let _data = JSON.parse(JSON.stringify(data || {}));
            _data['requiredfiles_set'] = required_files;
            return _data;
          })
        }
      } catch (error) {
        log.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <>
      <div className="cont">
        {/* <Navbar navbarClass="navbar-dark fixed-top" /> */}
        <Breadcrumb>
          <Breadcrumb.Item
            href={`/courseware/course/${courseId}/content/labs`}
          >
            Labs
          </Breadcrumb.Item>
          <Breadcrumb.Item
            href={`/courseware/course/${courseId}/content/labs/${labId}/`}
          >
            {labTitle}
          </Breadcrumb.Item>
          <Breadcrumb.Item
            href={`/courseware/course/${courseId}/content/labs/${labId}/other/${program_id}`}
          >
            {activityTitle}
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Submissions</Breadcrumb.Item>
        </Breadcrumb>

        <hr
          style={{
            height: "1px",
            border: "none",
            backgroundColor: "grey",
          }}
        />
      </div>
      <div style={{ display: "flex", height: "100%" }}>
        <div style={{ flex: "1 1 78%", paddingRight: "20px", overflowY: "auto" }}>
          <Card className="text-center" style={{ marginLeft: "10px", marginRight: "10px" }}>
            <Card.Header></Card.Header>
            <Card.Body style={{ backgroundColor: "#f0f3f8" }}>
              <Card.Title style={{ fontSize: "1.5rem", fontWeight: "bold", marginBottom: "10px" }}>{ }</Card.Title>
              <Card.Text style={{ fontSize: "1rem", marginBottom: "20px" }}>
                <span style={{ fontWeight: "bold", fontSize: 40, color: 'rgb(41, 121, 255)' }}>{otherActivityData?.name}</span><br />
                <div className="d-flex align-items-ceter justify-content-center gap-2" style={{ fontWeight: "bold", fonSize: 8, color: 'black' }}>
                  <span>Total Marks:</span>
                  {tot_marks === null ? <Skeleton size="1.5rem" className="mr-2"></Skeleton> : tot_marks}
                </div>
              </Card.Text>
              <div style={{ textAlign: "left", marginTop: "10px", fontWeight: "bold", fontSize: 14 }}>
                {otherActivityData?.description && typeof otherActivityData.description === 'string' ? parse(otherActivityData.description) : null}
              </div>
            </Card.Body>
          </Card>
          {log.log("ddd data ", otherActivityData)}
          {/*{otherActivityData?.question_set?.slice?.(0, Math.ceil(otherActivityData.question_set.length / 2)).map((activity, index) => (
            <div className="my-3"> 
              {log.log(activity,index,labId,isDisabled,activity_evaluated)}
              <Question
                question={activity}
                index={index}
                labId={labId}
                previousResponse={activity?.questionresponse_set || {}}
                // updateResponse={() => updateResponse2()} ref={(el) => (questionRefs.current[index] = el)}
                updateResponse={updateResponse}
                labAvailableTime={labAvailableTime}
                dis={isDisabled || false}
                Eval={activity_evaluated || false}
              />
              {log.log("inside question : "+Object.keys(activity.questionresponse_set) + " :: "+activity.questionresponse_set.response_options_ids)}
              
            </div>
          ))}*/}
          <div>
            {isLoading ? (
              <p>Loading...</p>
            ) : (
              otherActivityData?.question_set?.slice?.(0, Math.ceil(otherActivityData.question_set.length)).map((activity, index) => {
                try {
                  return (
                    <div className="my-3" key={index}>
                      {log.log(activity, index, labId, isDisabled, activity_evaluated)}
                      <Question
                        question={activity}
                        index={index}
                        labId={labId}
                        previousResponse={activity?.questionresponse_set || {}}
                        updateResponse={updateResponse}
                        dis={isDisabled || false}
                        Eval={activity_evaluated || false}
                        ref={(el) => (questionRefs.current[index] = el)}
                      />
                      {log.log("inside question : ", activity.questionresponse_set ? Object.keys(activity.questionresponse_set) : null)}
                    </div>
                  );
                } catch (error) {
                  log.error("Error occurred:", error);
                  return (
                    <div className="my-3" key={index}>
                      <p>Error occurred while rendering question.</p>
                    </div>
                  );
                }
              })
            )}
          </div>
        </div>
        <div style={{ flex: "1 1 22%", borderLeft: "0px solid #ccc", position: "sticky", top: 0, height: "20vh", zIndex: 1 }}>
          <div className="section-full-border" style={{ flex: 1, height: "max-content", marginBottom: "30px" }}>
            <h6 className="p-2 py-3" style={{ borderBottom: "1px solid #DFDFDF" }}>
              Questions
            </h6>
            <div className="p-2" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 15 }}>
              <div className="d-flex" style={{ gap: 10 }}>
                <div style={{ backgroundColor: moduleColors.rightAnswer, ...moduleBoxHWBr }}></div>
                <p style={moduleDesc} className="mb-0">Attempted</p>
              </div>
              <div className="d-flex" style={{ gap: 10 }}>
                <div style={{ backgroundColor: "#fff", border: "1px solid #757589", ...moduleBoxHWBr }}></div>
                <p style={moduleDesc} className="mb-0">Not Attempted</p>
              </div>
            </div>
            <div className="p-2" style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 16, maxWidth: 238 }}>
              {
                <div className="p-2" style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 16, maxWidth: 238 }}>
                  {otherActivityData && otherActivityData.question_set && otherActivityData.question_set.slice(0, Math.ceil(otherActivityData.question_set.length)).map((activity, index) => (
                    <div
                      key={`${index}`}
                      // onClick={() => setCurrentQuestionIndex(i)}
                      onClick={() => scrollToQuestion(index)}
                      style={{ ...getQuestionIndicatorStyle(activity, index, index), border: "2px solid black" }}>
                      {index + 1}
                    </div>
                  ))}
                </div>
              }
            </div>
          </div>
          <div style={{ marginLeft: '0px', marginBottom: '10px', fontWeight: 'bold', fontSize: '20px' }}>Subjective Grading</div>
          <div className="table-container-grade-submission" style={{ marginRight: "10px" }}>
            <table>
              <thead>
                <tr>
                  <th> Id </th>
                  <th> TA </th>
                  <th> Status </th>
                  <th> Marks </th>
                </tr>
              </thead>
              <tbody>
                {otherActivityData && otherActivityData.question_set &&
                  otherActivityData.question_set
                    .filter(activity => activity?.question_type === 'D')
                    .map((activity, index) => (
                      <tr key={index} style={{ cursor: 'pointer' }}>
                        <td>{index + 1}</td>
                        <td>{activity?.questionresponse_set?.graded_by ? activity?.questionresponse_set?.graded_by : `None`}</td>
                        <td className="status-cell">
                          {activity?.questionresponse_set?.graded ? <p className="status graded">graded</p> : <p className="status not-graded">Not Graded</p>}
                        </td>
                        <td><strong>{activity?.questionresponse_set?.scored_marks}</strong></td>
                      </tr>
                    ))
                }
              </tbody>
            </table>
          </div>
          {
            otherActivityData?.required_files_num > 0 ? <>
              <div className="d-flex justify-content-between align-items-center" style={{ marginLeft: '0px', marginRight: "10px", marginTop: '30px', marginBottom: '10px', }}>
                <div>
                  <p className="mb-0" style={{ fontWeight: 'bold', fontSize: '20px' }}>Submitted Files</p>
                  <small>(Required: {otherActivityData?.required_files_num})</small>
                </div>
                {log.log({otherActivityData})}
                {
                  otherActivityData?.requiredfiles_set?.filter(f => (f.isUploaded || f.id))?.length > 0 ?
                    <Button onClick={downloadLabFiles} size="sm" variant="primary">
                      Download
                    </Button> : <></>
                }

              </div>
              {
                otherActivityData?.requiredfiles_set?.length > 0 ? <>
                  <Card className="background-white p-0" style={{ marginTop: 10, padding: "10px", border: "1px solid #ddd", marginRight: '10px' }}>
                    <Card.Body className="p-2">
                      <ol className="mb-0">
                        {
                          otherActivityData?.requiredfiles_set?.map?.((file, index) => {
                            return <li>{(file?.name || file?.required_file_name)}</li>
                          })
                        }
                      </ol>
                    </Card.Body>
                  </Card>
                </> : <>
                  <Card className="background-white" style={{ marginTop: 10, padding: "10px", border: "1px solid #ddd" }}>
                    No files Submitted
                  </Card>
                </>
              } </> : <></>
          }
        </div>
      </div>
    </>
  );
}
const moduleColors = {
  partiallyAttempted: "#F1D560",
  currentlySelected: "#007BFF",
  wrongAnswer: "#C71B16",
  noAction: "#757589",
  rightAnswer: "#57BD72",
}

const moduleBoxHWBr = {
  borderRadius: 4,
  width: 20,
  height: 20,
}

const moduleDesc = {
  color: "#757589",
  fontSize: 12
}

const questionsModule = {
  width: 35,
  height: 34,
  borderRadius: "50%",
  border: "1px solid #DFDFDF",
  fontSize: 14,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer"
}

const questions = {
  rightAnswer: { backgroundColor: moduleColors.rightAnswer, color: "#fff", ...questionsModule },
  partiallyAttempted: { backgroundColor: moduleColors.partiallyAttempted, color: "#fff", ...questionsModule },
  currentlySelected: { ...questionsModule, border: "3px solid black" },
  wrongAnswer: { backgroundColor: moduleColors.wrongAnswer, color: "#fff", ...questionsModule },
  noAction: { color: moduleColors.noAction, backgroundColor: "#fff", ...questionsModule }
}

/*const getQuestionIndicatorStyle = (q, i, currentQuestionIndex) => {
  // currentQuestionIndex === (i) ? questions.currentlySelected : questions.noAction
  // log.log({ q, i, currentQuestionIndex });
  let styleToReturn = {};
  if (q.question_history && q.question_history.length && q.question_history.length > 0) {
      // log.log({ opopo: q });
      let qh = q.question_history[0];
      // log.log({ qh, q });
      if (q.attempts === qh.attempts) {
          if (qh.answer_shown && qh.marks) {
              styleToReturn = questions.rightAnswer;
          } else {
              styleToReturn = questions.wrongAnswer;
          }
      } else {
          if (qh.answer_shown && qh.marks) {
              styleToReturn = questions.rightAnswer;
          } else {
              styleToReturn = questions.partiallyAttempted;
          }
      }
  } else {
      styleToReturn = questions.noAction;
  }
  if (currentQuestionIndex === i) {
      styleToReturn = { ...styleToReturn, ...questions.currentlySelected };
  }
  return styleToReturn;
}*/
const getQuestionIndicatorStyle = (activity, i, currentQuestionIndex) => {
  let styleToReturn = {};

  // Check if response text is not empty
  if (activity?.questionresponse_set?.response_text || activity?.questionresponse_set?.response_options_ids?.length > 0) {
    styleToReturn = { backgroundColor: "lightgreen", ...questionsModule };
  } else {
    styleToReturn = { backgroundColor: "white", ...questionsModule };
  }

  // Add logic for current question index
  if (currentQuestionIndex === i) {
    styleToReturn = { ...styleToReturn, ...questions.currentlySelected };
  }

  return styleToReturn;
};

export default GradeSubmission;
